var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgProfileFilledIcon = function SvgProfileFilledIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2208_42529)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2208_42529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12.7C14.7 12.7 16.9 10.5 16.9 7.8C16.9 5.1 14.7 3 12 3C9.30001 3 7.10001 5.2 7.10001 7.9C7.10001 10.6 9.30001 12.8 12 12.8V12.7ZM12 12.7C14.2 12.7 16.3 13.6 17.9 15.1C19.5 16.7 20.3 18.8 20.3 21H3.70001C3.70001 18.8 4.60001 16.7 6.10001 15.1C7.70001 13.5 9.80001 12.7 12 12.7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.7C14.7 12.7 16.9 10.5 16.9 7.8C16.9 5.1 14.7 3 12 3C9.30001 3 7.10001 5.2 7.10001 7.9C7.10001 10.6 9.30001 12.8 12 12.8V12.7ZM12 12.7C14.2 12.7 16.3 13.6 17.9 15.1C19.5 16.7 20.3 18.8 20.3 21H3.70001C3.70001 18.8 4.60001 16.7 6.10001 15.1C7.70001 13.5 9.80001 12.7 12 12.7Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13C14.7614 13 17 10.7614 17 8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8C7 10.7614 9.23858 13 12 13Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2208_42529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2208_42529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6,
    height: 20,
    fill: "white",
    transform: "translate(2.70001 2)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProfileFilledIcon);
export default ForwardRef;